import { PropsWithChildren, ReactNode } from 'react';
import { PASTE_HOST_PROPS } from './expertLayout';
import { useExpertMode } from './useExpertMode';

interface WithExcelPastePanelProps {
  /** The paste panel of this tariff, none renders the tariff alone. */
  panel: ReactNode;
  isViewMode?: boolean;
}

/**
 * Puts a tariff with its paste panel in Expert mode; renders the tariff alone
 * otherwise, or when the sheet is only being viewed.
 */
const WithExcelPastePanel = ({
  panel,
  isViewMode = false,
  children,
}: PropsWithChildren<WithExcelPastePanelProps>) => {
  const expertMode = useExpertMode();
  if (!expertMode || isViewMode || !panel) return <>{children}</>;

  // Side by side from xl, where the column makes room for the panel (see
  // `expertLayout`), stacked with the panel first below.
  return (
    <div
      {...PASTE_HOST_PROPS}
      className="grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,1fr)_360px]"
    >
      <div className="min-w-0 order-2 xl:order-1">{children}</div>
      <div className="order-1 xl:order-2">{panel}</div>
    </div>
  );
};

export default WithExcelPastePanel;
